define(function () {
    if (window.scan && window.scan.pdfRedirect) {
        var url = window.location.href;
        var arr = url.split("/");
        var host = arr[0] + "//" + arr[2];
        window.location.href = host + window.scan.pdfRedirect;
    }
});
